import restApi from "../../http.js";

const defaultPageLimit = 36;

export default class NavigationApi {
  getNavigation() {
    return restApi({
      method: "GET",
      url: "/views/containers",
      params: {
        type: "NAVIGATION",
      },
    });
  }

  getProductsForComponent(id) {
    return restApi({
      method: "GET",
      url: `/views/components/${id}/products`,
    });
  }
  getProductsForContainer(id) {
    return restApi({
      method: "GET",
      url: `/views/containers/${id}/products`,
    });
  }

  getProductsFromParentCategory(id, page = 0, limit = defaultPageLimit) {
    return restApi({
      method: "GET",
      url: `/views/containers/${id}/products`,
      params: {
        limit: limit,
        page: page,
      },
    });
  }
  getProductsFromChildCategory(id, page = 0, limit = defaultPageLimit) {
    return restApi({
      method: "GET",
      url: `/views/components/${id}/products`,
      params: {
        limit: limit,
        page: page,
      },
    });
  }
}
